import React, { useState, useEffect, useRef, Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@/app/global-components/button";
import { isEmpty } from "lodash";
import moment from "moment";
import { Link as LinkTo } from "react-router-dom";
import { RootState } from "@/store/type";
import { useSelector } from "react-redux";
import CompanyInfoCard from "./CompanyInfoCard";
import regionsData from "@/app/features/company/data/regions_lite.json";
import citiesData from "@/app/features/company/data/cities_lite.json";
import ListofQuatations from "./list-of-Quatations";
import { Tabs, Tab, Box } from "@mui/material";
import TenderStepper from "./header";
import TenderEdFormView from "./tender-Editform-view";
//import CloseOfferSubmitView from "./tender-close-submit-view";
import TenderCloseFormView from "./tender-Closeform-view";
import PrintIcon from "@mui/icons-material/Print";
import ShareIcon from "@mui/icons-material/Share";
import QuatationsStatistics from "./statistic.Quatations";
import { generatePDFWithForm } from "../service/generatepdf";
import MarkteComponent from "./MarkteComponent";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG, ROLE } from "@/types";
import { showToast } from "@/app/global-components/toaster";
import { routes } from "@/consts";
import { cn } from "@/lib/utils";
import useRegisterCompany from "@/hooks/use-register-company";
import useOffer from "@/hooks/useTender";
interface Product {
  item: string;
  quantity: number;
  unit: string;
  attachment: File | null; // Assuming it's a file name or URL
  notice: string;
}
export interface CompanySchema {
  id: string;
  nameAr: string;
  nameEn: string;
  CompanyNr: string;
  website?: string; // Optional field
  contactInfo?: string; // Optional field
  city?: string; // Optional field
  region?: string; // Optional field
}
interface OfferShema {
  title: string;
  minValue: number;
  value: number;
  endDate: string;
  deliverDate: string;
  type: string;
  status: string;
  categories: string[];
  categoriesIds: string[];
  region: string;
  city: string;
  fileName: string;
  fileDescription: string;
  attachmentName: string;
  attachmentDescription: string;
  receiveDocumentsType: string;
  contactInfo: string;
  products: Product[];
  Paylater: string;
  attachmentDeliverDays: number | null;
  attachmentId: string | null;
  attachmentRequired: boolean;
  companyId: string;
  fileId: string | null;
  id: string | null;
  userId: string;
}
interface Offer {
  title: string;
  minValue: number;
  value: number;
  endDate: string;
  deliverDate: string;
  type: string;
  status: string;
  categories: string[];
  region: string;
  city: string;
  fileName: string;
  fileDescription: string;
  attachmentName: string;
  attachmentDescription: string;
  receiveDocumentsType: string;
  contactInfo: string;
  TenderNr: string;
  products: Product[]; // Include products array
}
interface City {
  city_id: number;
  region_id: number;
  name_ar: string;
}
interface Region {
  region_id: number;
  name_ar: string;
}
interface Option {
  value: string;
  label: string;
}

const TenderInfoView: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const { id } = useParams();
  const authUser = useSelector((state: RootState) => state.auth.authUser);

  const { getOffer, isLoading, error } = useOffer();
  const { getCompany } = useRegisterCompany();
  const [offer, setOffer] = useState<Offer | null>(null);
  const [offerED, setOfferEd] = useState<OfferShema | null>(null);
  const [company, setCompany] = useState<CompanySchema | null>(null);
  const navigate = useNavigate();
  const [regions, setRegions] = useState<Option[]>([]);
  const [cities, setCities] = useState<Option[]>([]);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(() => {
    setRegions(
      regionsData.map((region: Region) => ({
        value: region.region_id.toString(), // Convert to string
        label: region.name_ar,
      }))
    );
  }, []);
  useEffect(() => {
    setCities(
      citiesData.map((City: City) => ({
        value: City.city_id.toString(),
        label: City.name_ar,
      }))
    );
  }, []);
  const getCity = (value: string) => {
    let city = cities.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  const getRegion = (value: string) => {
    let city = regions.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  const onupdateNew = async () => {
    if (id) {
      try {
        const offerData = await getOffer(id);
        if (offerData) {
          setOffer(offerData.data);
          setOfferEd(offerData.data);
          const Company = await getCompany(offerData.data.companyId);
          setCompany(Company.data);
        } else {
          navigate(routes.home);
        }
      } catch (error) {
        console.log(error);
        // navigate("/");
      }
    }
  };
  useEffect(() => {
    const fetchOfferCard = async () => {
      if (id) {
        try {
          const offerData = await getOffer(id);
          if (offerData) {
            setOffer(offerData.data);
            setOfferEd(offerData.data);
            const Company = await getCompany(offerData.data.companyId);
            setCompany(Company.data);
          } else {
            navigate(routes.home);
          }
        } catch (error) {
          console.log(error);
          // navigate("/");
        }
      }
    };

    fetchOfferCard();
  }, [id]);

  if (!offer) {
    return null;
  }
  const handlePrint = (offer: Offer) => {
    generatePDFWithForm({
      ...offer,
      region: getRegion(offer.region),
      city: getCity(offer.city),
      company: {
        ...company,
        region: company ? getRegion(company.region || "") : "",
        city: company ? getCity(company.city || "") : "",
        id: company ? company.id || "" : "",
        CompanyNr: company ? company.CompanyNr || "" : "",
        nameAr: company ? company.nameAr || "" : "",
        nameEn: company ? company.nameEn || "" : "",
      },
    });
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t("tenders.info"),
          text: t("tenders.information"),
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      showToast(t("Alert.SharingNotSupported"), "warning");
    }
  };
  const ShowInfo = () => {
    return (
      <div className="p-3">
        <div className="flex" style={{ justifyContent: "space-between" }}>
          <div className="flex gap-6 items-center">
            <div className="w-6 h-3 bg-purple-600"></div>
            <h3 className="tracking-tight text-3xl font-bold">
              {t("quotations.requestFor")}
            </h3>
          </div>
          <div className="flex gap-4 mb-4" style={{ maxWidth: 100 }}>
            <Button
              className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-1 px-3 text-sm"
              style={{
                background: "#000",
                color: "#fff",
                visibility: "hidden",
              }}
              onClick={() => handlePrint(offer)}
            >
              <PrintIcon />
            </Button>
            <Button
              className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-1 px-3 text-sm"
              style={{ background: "#000", color: "#fff" }}
              onClick={handleShare}
            >
              <ShareIcon />
            </Button>
          </div>
        </div>
        {authUser && (
          <div className="py-6">
            <TenderStepper status={offer?.status || "Planning"} />
          </div>
        )}
        {offer.status === "Planning" ||
          (authUser?.role === ROLE.BUYER &&
          (offer.status === "Opened" || offer.status === "Closed") ? (
            <TenderEdFormView offer={offerED} updateNew={onupdateNew} />
          ) : (
            <>
              <div>
                {company ? (
                  <div className="pb-6 sliced-border">
                    <CompanyInfoCard
                      company={company}
                      OpportunityNr={offer.TenderNr}
                    />
                  </div>
                ) : (
                  <>{t("general.CompanyNotAvailable")}</>
                )}
              </div>
              <div className="mt-20">
                <div className="lg:text-xl">
                  <div className="mt-2 gap-y-6 grid lg:grid-cols-3">
                    <div>
                      <strong>{t("tender.value")}: </strong>
                      {offer.value}
                    </div>
                    <div>
                      <strong>{t("offers.fields.submissionDeadline")}: </strong>
                      {moment(offer.endDate).format("YYYY-MM-DD")}{" "}
                    </div>
                    <div>
                      <strong>{t("offers.fields.openingDate")}: </strong>
                      {moment(offer.deliverDate).format("YYYY-MM-DD")}{" "}
                    </div>
                    <div>
                      <strong>{t("orders.fields.status")}: </strong>
                      {offer.status}{" "}
                    </div>
                    <div>
                      <strong>{t("item.fields.categories")}: </strong>
                      {isEmpty(offer.categories)
                        ? ""
                        : offer.categories.slice(0, 5).join(", ")}{" "}
                    </div>
                    <div>
                      <strong>{t("general.DocumentReceptionType")}: </strong>
                      {offer.receiveDocumentsType}
                    </div>
                    <div>
                      <strong>{t("attachments.fileName")}: </strong>
                      {!offer.fileName
                        ? t("general.Unavailabe")
                        : offer.fileName}{" "}
                    </div>
                    <div>
                      <strong>{t("attachments.fileDesc")}: </strong>
                      {!offer.fileDescription
                        ? t("general.Unavailabe")
                        : offer.fileDescription}{" "}
                    </div>
                    <div>
                      <strong>{t("attachments.name")}: </strong>
                      {!offer.attachmentName
                        ? t("general.Unavailabe")
                        : offer.attachmentName}{" "}
                    </div>
                    <div>
                      <strong>{t("attachments.description")}: </strong>
                      {isEmpty(offer.attachmentDescription)
                        ? t("general.Unavailabe")
                        : offer.attachmentDescription}{" "}
                    </div>
                    <div>
                      <strong>{t("attachments.required")}: </strong>
                      {offer.attachmentDescription
                        ? t("general.yes")
                        : t("general.no")}{" "}
                    </div>
                  </div>
                  {authUser?.role === ROLE.BUYER &&
                    offer.status === "Opened" && (
                      <TenderCloseFormView
                        offer={offerED}
                        updateNew={onupdateNew}
                      />
                    )}

                  {offer.products && offer.products.length > 0 && (
                    <div className="my-20">
                      <div className="overflow-x-auto w-full">
                        <div className="mt-4 w-full min-w-[700px]">
                          <div className="border border-gray-300 font-semibold rounded-xl grid grid-cols-5 w-full">
                            <div
                              className={cn(
                                "p-2 min-w-[150px]",
                                locale === LANG.AR ? "text-right" : "text-left"
                              )}
                            >
                              {t("offers.item")}
                            </div>
                            <div
                              className={cn(
                                "p-2 min-w-[150px]",
                                locale === LANG.AR ? "text-right" : "text-left"
                              )}
                            >
                              {t("checkout.fields.quantity")}
                            </div>
                            <div
                              className={cn(
                                "p-2 min-w-[150px]",
                                locale === LANG.AR ? "text-right" : "text-left"
                              )}
                            >
                              {t("item.fields.unit")}
                            </div>
                            <div
                              className={cn(
                                "p-2 min-w-[150px]",
                                locale === LANG.AR ? "text-right" : "text-left"
                              )}
                            >
                              {t("offers.attachment")}
                            </div>
                            <div
                              className={cn(
                                " p-2  min-w-[150px]",
                                locale === LANG.AR ? "text-right" : "text-left"
                              )}
                            >
                              {t("orders.fields.notes")}
                            </div>
                          </div>

                          <div className="grid grid-cols-5 w-full">
                            {offer.products.map((product, index) => (
                              <Fragment key={index}>
                                <div className="px-4 py-2">{product.item}</div>
                                <div className="px-4 py-2">
                                  {product.quantity}
                                </div>
                                <div className="px-4 py-2">{product.unit}</div>
                                <div className="px-4 py-2">
                                  {product.attachment ? (
                                    <a
                                      href={URL.createObjectURL(
                                        product.attachment
                                      )}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {t("attachments.view")}
                                    </a>
                                  ) : (
                                    t("general.Unavailabe")
                                  )}
                                </div>
                                <div className="px-4 py-2">
                                  {product.notice}
                                </div>
                              </Fragment>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div>
                    {authUser?.role === ROLE.SELLER && (
                      <>
                        <div className="flex flex-col items-end">
                          <LinkTo
                            className="flex rounded-xl items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-2 px-4 text-sm"
                            to={`${routes.quatation}/${id}`}
                            style={{
                              justifyContent: "center",
                              background: "#000",
                              color: "#fff",
                              maxWidth: 150,
                            }}
                          >
                            {t("quotations.submit")}
                          </LinkTo>
                        </div>
                        <div className="mt-16">
                          <ListofQuatations
                            offerID={id || ""}
                            offerStatus={offer?.status || "Planning"}
                            updateNew={onupdateNew}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {!authUser && (
                  <div
                    className="mt-20 mx-auto border p-4 rounded-xl bg-gray-100"
                    style={{ maxWidth: 400 }}
                  >
                    <div className="m-4 font-medium">
                      {t("quotations.information")}
                    </div>
                    <div className="flex gap-4">
                      <LinkTo
                        to={routes.login}
                        state={{ role: ROLE.SELLER }}
                        className="flex rounded-md items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-2 px-4 text-sm"
                        style={{
                          justifyContent: "center",
                          background: "#000",
                          color: "#fff",
                        }}
                      >
                        {t("authentication.login")}
                      </LinkTo>
                      <LinkTo
                        to={routes.register}
                        className="flex rounded-md items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-2 px-4 text-sm"
                        style={{
                          justifyContent: "center",
                          background: "#000",
                          color: "#fff",
                        }}
                      >
                        {t("workflow.createAccount.title")}
                      </LinkTo>
                    </div>
                  </div>
                )}
              </div>
            </>
          ))}
      </div>
    );
  };

  const renderTabContent = () => {
    switch (selectedTab) {
      case 0:
        return ShowInfo();
      case 1:
        return (
          <ListofQuatations
            offerID={id || ""}
            offerStatus={offer?.status || "Planning"}
            updateNew={onupdateNew}
          />
        );

      case 2:
        return <QuatationsStatistics offerID={id || ""} />;
      case 3:
        return <MarkteComponent offerID={id || ""} />;
      default:
        return null;
    }
  };
  if (isLoading) {
    return <div>{t("status.loading")}</div>;
  }

  if (error) {
    return <div>{t("alerts.error.Errorloadingoffer")}</div>;
  }
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-5 w-full md:flex-row space-x-4">
        <section className="w-full" ref={sectionRef}>
          {authUser && authUser.role === ROLE.BUYER ? (
            <>
              <Tabs
                value={selectedTab}
                onChange={(e, newValue) => {
                  console.log(e);
                  setSelectedTab(newValue);
                }}
                sx={{
                  borderBottom: "1px solid #e6e6e6", // Add border-bottom
                  mb: 2, // Optional: Add some margin below the tabs
                  justifyContent: "flex-start", // Align tabs to the right
                  "& .MuiTabs-flexContainer": {
                    justifyContent: "flex-start", // Align tabs to the right
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#644980", // Set the indicator color to #644980
                  },
                }}
              >
                <Tab
                  label={t("general.information")}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    color: "#644980",
                    "&.Mui-selected": {
                      color: "#644980",
                    },
                  }}
                />
                <Tab
                  label={t("statistics.Offers")}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    color: "#644980",
                    "&.Mui-selected": {
                      color: "#644980",
                    },
                  }}
                />
                <Tab
                  label={t("statistics.title")}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    color: "#644980",
                    "&.Mui-selected": {
                      color: "#644980",
                    },
                  }}
                />
                <Tab
                  label={t("general.store")}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    color: "#644980",
                    "&.Mui-selected": {
                      color: "#644980",
                    },
                  }}
                />
              </Tabs>
              <Box>{renderTabContent()}</Box>
            </>
          ) : (
            <>{renderTabContent()}</>
          )}
        </section>
      </div>
    </div>
  );
};

export default TenderInfoView;
